import { FETCH_CORRESPONSALES_FAILURE, FETCH_CORRESPONSALES_SUCCESS } from '../actions/corresponsales/types';

const initialState = {
  data: [],
};

const corresponsalesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CORRESPONSALES_SUCCESS:
      return {
        ...state,
        data: action.payload,
      };
    case FETCH_CORRESPONSALES_FAILURE:
      return {
        ...state,
        data: action.payload,
      };
    default:
      return state;
  }
};

export default corresponsalesReducer;
